import MapLocationSelect from "@/components/mapping/MapLocationSelect"
import type { LatLng } from "@/models"
import { defineComponent, inferProps, proxyProp, type ReactiveComponent } from "vue-utils"

interface Props {
	showLatLngInputs: boolean
	position: LatLng
	isReadOnly: boolean
	isSubmitting?: boolean
	markerFilter?: string

	setLocation(loc: LatLng): void
	cancel(): void
}

const PickLocationFromMap: ReactiveComponent<Props> = (props) => {
	const position = proxyProp(props, "position")

	return () => (
		<MapLocationSelect
			showLatLngInputs={props.showLatLngInputs}
			locationName={`${props.showLatLngInputs ? "" : "Additional"} Incident Location`}
			location={position}
			setLocation={props.setLocation}
			cancel={props.cancel}
			readOnly={props.isReadOnly}
			submitting={props.isSubmitting}
			markerFilter={props.markerFilter}
		/>
	)
}

export default defineComponent(PickLocationFromMap, inferProps<Props>())
